import React from 'react';

import {CircularProgress, Card, Stack, Link} from "@mui/joy";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Sheet from "@mui/joy/Sheet";
import Avatar from "@mui/joy/Avatar";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import RoomCreateModal from "./RoomCreateModal";
import retrievePermission from "../../utils/retrievePermission";


class MessengerSidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            roomSubscribers: null,
            displayMenu: true,
            createPermission: 0,
            listFilter: null,
        }
    }

    async componentDidMount() {
        await this.retrieveCreatePermission();
        await this.retrieveRooms();
        this.timer = setInterval(
            this.retrieveRooms.bind(this),
            10000
        );
    }

    async retrieveCreatePermission() {
        let createPermission = await retrievePermission(
            'RoomViewSet',
            'create',
            this.context.subscriberObject
        );
        this.setState(
            {
                createPermission: createPermission,
            }
        )
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    setRoomSubscriber(roomSubscriber) {
        this.props.setRoomSubscriberCallBack(roomSubscriber)
        this.setState(
            {
                displayMenu: false,
            }
        )
    }

    async retrieveRooms() {
        this.setState({
            rooms: null,
        });
        const url = 'room_subscriber/';
        const params = {
            subscriber: this.context.subscriberObject.id,
            page_size: 10000,
            archived: false,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        this.setState({
            roomSubscribers: response.data.results,
        });
    }

    async createCallBack(room) {
        await this.retrieveRooms();
        await this.props.createCallBack(room);
    }

    openMenu() {
        this.setState(
            {
                displayMenu: true,
            }
        )
    }

    render() {
        if (!this.state.roomSubscribers) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Sheet
                variant={'plain'}
                sx={{
                    position: {
                        xs: 'relative',
                        lg: 'sticky',
                    },
                    transition: 'transform 0.4s',
                    zIndex: 998,
                    height: '100%',
                    maxWidth: '100%',
                    width: {
                        xs: '100%',
                        lg: '300px',
                    },
                    // top: 0,
                    flexShrink: 0,
                    display: {
                        xs: this.state.displayMenu ? 'flex' : 'none',
                        lg: 'flex'
                    },
                    flexDirection: 'column',
                    gap: 1,
                    overflow: 'scroll',
                }}
            >
                <Card
                    size={'sm'}
                    variant={'soft'}
                    sx={{
                        mb: 2,
                        minHeight: '60px',
                    }}
                >
                    <Stack
                        direction={'row'}
                        spacing={1}
                    >
                    {
                        this.state.createPermission ?
                            <>
                                <RoomCreateModal
                                    callBack={this.createCallBack.bind(this)}
                                />
                                <RoomCreateModal
                                    label={'Бот'}
                                    color={'warning'}
                                    xtype={'BOT'}
                                    callBack={this.createCallBack.bind(this)}
                                    pushFirstMessage={true}
                                />
                            </>
                            :
                            null
                    }
                    <Button
                        component="a"
                        href={'/games/road_runner'}
                        size={'sm'}
                        color={'lime'}
                        target={'_blank'}
                        sx={{
                            '&:visited': {
                                color: 'green',
                            },
                        }}
                    >
                        Игра
                    </Button>
                    </Stack>
                </Card>
                <Card
                    size={'sm'}
                    variant={'soft'}
                >
                    <Stack
                        direction={'row'}
                        spacing={0.5}
                        sx={{
                            width: '100%',
                            overflowX: 'scroll',
                            minHeight: '38px',
                            maxHeight: '38px',
                        }}
                    >
                        <Button
                            size={'sm'}
                            variant={this.state.listFilter ? 'soft' : 'solid'}
                            onClick={() => {
                                this.setState({listFilter: null})
                            }}
                        >
                            Все
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.listFilter === 'GROUP' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setState({listFilter: 'GROUP'})
                            }}
                        >
                            Группы
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.listFilter === 'ONETOONE' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setState({listFilter: 'ONETOONE'})
                            }}
                        >
                            Личные
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.listFilter === 'BOT' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setState({listFilter: 'BOT'})
                            }}
                            color={'warning'}
                        >
                            Бот
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.listFilter === 'SUSPENDED' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setState({listFilter: 'SUSPENDED'})
                            }}
                            color={'neutral'}
                        >
                            Приостановлены
                        </Button>
                    </Stack>
                </Card>

                <Stack
                    spacing={1}
                    sx={{
                        flexGrow: 10,
                        width: '100%',
                        overflowY: 'scroll',
                    }}

                >

                    {
                        this.state.roomSubscribers.filter(
                            r => {
                                if (!this.state.listFilter ){
                                    return !r.suspended
                                }
                                else if (this.state.listFilter === 'SUSPENDED') {
                                    return r.suspended
                                }
                                else {
                                    return r.room.xtype === this.state.listFilter && !r.suspended
                                }
                            }
                        ).map(roomSubscriber => (
                        <Card
                            size={'sm'}
                            variant={'soft'}
                            onClick={this.setRoomSubscriber.bind(this, roomSubscriber)}
                            sx={{
                                cursor: 'pointer',
                            }}
                            key={'RoomSideCard' + roomSubscriber.room.id}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                sx={{
                                    height: '60px',
                                    overflow: 'hidden',
                                }}
                            >
                                <Avatar
                                    color={roomSubscriber.room.xtype === 'BOT' ? 'warning' : 'primary'}
                                >
                                    {roomSubscriber.room.xtype === 'ONETOONE' ? roomSubscriber.title.slice(0, 2) : roomSubscriber.room.title.slice(0, 2)}
                                </Avatar>
                                <Stack
                                    spacing={0}
                                    sx={{
                                        overflow: 'hidden'
                                    }}
                                >
                                    <Stack
                                        direction={'row'}
                                        spacing={2}
                                        sx={{
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            level={'body-sm'}
                                        >
                                            <strong>{roomSubscriber.room.xtype === 'ONETOONE' ? roomSubscriber.title.slice(0, 30) : roomSubscriber.room.title.slice(0, 30)}</strong>
                                        </Typography>
                                        {
                                            roomSubscriber.unread_count ?
                                                <Chip
                                                    variant={'soft'}
                                                    color={'primary'}>
                                                    {roomSubscriber.unread_count}
                                                </Chip> : null
                                        }
                                        {
                                            roomSubscriber.mention_count ?
                                                <Chip
                                                    variant={'soft'}
                                                    color={'warning'}>
                                                    @{roomSubscriber.unread_count}
                                                </Chip> : null
                                        }
                                    </Stack>
                                    <Typography
                                        level={'body-sm'}
                                        sx={{
                                            pt: 0.5
                                        }}
                                    >
                                        {roomSubscriber.last_message?.owner?.user?.first_name} {roomSubscriber.last_message?.owner?.user?.last_name}
                                    </Typography>
                                    <Typography
                                        level={'body-sm'}
                                    >
                                        {
                                            roomSubscriber.last_message?.xtype === 'COMMON' ?
                                                roomSubscriber.last_message?.content?.slice(0, 50) :
                                                '🖼️'
                                        }
                                    </Typography>
                                </Stack>
                            </Stack>

                        </Card>
                    ))}
                </Stack>

            </Sheet>
        )
    }
}

export default MessengerSidebar;
